"use strict";

require("core-js/modules/es6.array.find");

if (!Array.prototype.find) {
  require("./array.find");
}